import api from "@helpers/api";
import { t } from "@i18n";
import { materialWriteBody } from "./materialWriteBody";

/**
 * Update an existing material
 * @param {UpdateMaterialDTO} materialDTO - Material data transfer object
 * @returns {Promise<{success: boolean, data?: Object, error?: string}>}
 */
export async function updateMaterial(materialDTO) {
    try {
        const payload = materialDTO.toPayload();
        const materialId = materialDTO.getId();
        const body = materialWriteBody(payload);
        const { data } = await api.patch(`material/${materialId}`, body);

        if (data.id) {
            return { success: true, data };
        }

        return {
            success: false,
            error: t('contentModals:manageMaterial.errors.updateFailed')
        };
    } catch (error) {
        console.error('Error updating material:', error);

        return {
            success: false,
            error: t('contentModals:manageMaterial.errors.saveFailed')
        };
    }
}
